import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/dist/MotionPathPlugin';
import { Beheaded } from '../../Beheaded';
import { GraveSnatchers } from '../../Font/GraveSnatchers';
import { BeheadedEngineManager } from '../../reels/BeheadedEngineManager';
import { BeheadedSymbol } from '../../reels/symbol/BeheadedSymbol';
import { Helper } from '../../../core/utils/Helper';
import { SpinePlayer } from '../../../core/displayobject/SpinePlayer';
import { MathHelper } from '../../../core/utils/MathHelper';
import { TranslationTexts } from '../../config/translate/TranslationTexts';
import { GameSetting } from '../../../core/setting/GameSetting';
import { SoundConfig } from '../../config/sound/SoundConfig';
import { SoundManager } from '../../config/sound/SoundManager';

gsap.registerPlugin(MotionPathPlugin);

export class SoulWild extends PIXI.Container {
    // public swirlySpine: AbstractSpine;

    private amountOfSW: number = 3;

    private swirlySpine: SpinePlayer;
    private soulWilds: SpinePlayer[] = [];
    private addSpinsText: PIXI.Text;
    private addSpinsText2: PIXI.Text;

    private symbolsToGetSucky: BeheadedSymbol[];

    public static volumeFire: number = 1;

    private fsTextStyle: any = {
        fontFamily: GraveSnatchers.FAMILY,
        fontSize: '40px',
        stroke: '#000000',
        strokeThickness: 10,
        fill: '#265cff',
        dropShadow: true,
        dropShadowColor: '#000000',
        dropShadowAlpha: 0.7,
        dropShadowAngle: 0.6,
        dropShadowDistance: 8,
        padding: 20,
        lineJoin: 'round',
    };

    private fsTextStyle2: any = {
        fontFamily: GraveSnatchers.FAMILY,
        fontSize: '15px',
        stroke: '#000000',
        strokeThickness: 10,
        fill: '#265cff',
        dropShadow: true,
        dropShadowColor: '#000000',
        dropShadowAlpha: 0.7,
        dropShadowAngle: 0.6,
        dropShadowDistance: 8,
        padding: 20,
        lineJoin: 'round',
    };

    // 1x1, 2x2, 3x3
    // 1x1_W_appear, 1x1_W_loop, 1x1_W_win

    constructor() {
        super();
        this.init();
    }

    private init(): void {
        this.swirlySpine = new SpinePlayer(`swirl_zone`);

        for (let i = 0; i < this.amountOfSW; i++) {
            this.soulWilds.push(this.addChild(new SpinePlayer('soul_wild_' + ['green', 'purple', 'red'][i])));
        }
        Beheaded.reelEngineManager.addSwirl(this.swirlySpine);
        this.createTexts();
    }

    createTexts(): void {
        this.addSpinsText = this.addChild(new PIXI.Text('+1'));
        this.addSpinsText.style = this.fsTextStyle;
        this.addSpinsText.anchor.set(0.5, 0.5);
        this.addSpinsText.alpha = 0;

        this.addSpinsText2 = this.addChild(new PIXI.Text(`${TranslationTexts.FREESPINS}`));
        this.addSpinsText2.style = this.fsTextStyle2;
        this.addSpinsText2.alpha = 0;
        this.addSpinsText2.anchor.set(0.5, 0.5);
        this.addSpinsText2.pivot.set(0, -40);
    }

    //target is Top Left Symbol
    public show(target: { reel: number; row: number }, size: number): gsap.core.Timeline {
        this.swirlySpine.parent.zIndex = -1;
        this.swirlySpine.parent.sortChildren();
        // Break out the rope from the conflicting Z Container.
        BeheadedEngineManager.RAll((r) => r.switchRopeLayer(true));

        const tl = gsap.timeline({
            onComplete: () => {
                this.swirlySpine.parent.zIndex = 5;
                this.swirlySpine.parent.sortChildren();
            },
        });

        tl.timeScale(GameSetting.isFastSpin ? 1.5 : 1);

        const sym = BeheadedEngineManager.getReel(target.reel).getSymbol(target.row) as BeheadedSymbol;

        this.swirlySpine.position = Helper.copyLocalPosition(this.swirlySpine, sym);
        if (size == 2)
            this.swirlySpine.position = MathHelper.pointAdd(
                this.swirlySpine.position,
                new PIXI.Point(sym.symbolWidht / 2, sym.symbolHeight / 2)
            );
        else if (size == 3)
            this.swirlySpine.position = MathHelper.pointAdd(
                this.swirlySpine.position,
                new PIXI.Point(sym.symbolWidht, sym.symbolHeight)
            );

        let scatterCounter: number = 0;
        this.symbolsToGetSucky = [];

        for (let reel = target.reel; reel < target.reel + size; reel++) {
            for (let row = target.row; row < target.row + size; row++) {
                const sym = BeheadedEngineManager.getReel(reel).getSymbol(row)!;
                this.symbolsToGetSucky.push(sym);
                scatterCounter += sym.isScatter ? 1 : 0;
            }
        }

        let startOffset: number = 0;

        const swirlAnim: string = size + 'x' + size;
        tl.add(() => {
            this.swirlySpine.play({ animation: swirlAnim, loop: true });
        }, startOffset);

        tl.fromTo(
            this.swirlySpine,
            { alpha: 0 },
            {
                alpha: 1,
                duration: 0.8,
                onStart: () => {
                    SoulWild.volumeFire = size === 1 ? 0.5 : size === 2 ? 0.75 : 1;
                    Beheaded.soundPlayer.playSound(SoundConfig.WILD_FIRE_LOOP, SoulWild.volumeFire, 10);
                },
            },
            startOffset
        );
        tl.fromTo(this.swirlySpine.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.8 }, startOffset);

        startOffset += 0.4;

        this.setSwPositions(size);

        tl.add(() => { Beheaded.soundPlayer.playSound(SoundConfig.SHAKE_SYMBOLS) },0);
        this.symbolsToGetSucky.forEach((sym) => {
            sym.shake();

            const toPos = Helper.copyLocalPosition(sym, this.swirlySpine);
            tl.to(sym, { x: toPos.x, y: toPos.y, duration: 1.2, ease: 'Back.easeIn' }, 0);

            tl.to(sym.scale, { x: 0, y: 0, duration: 0.4, ease: 'Power3.easeIn' }, startOffset + 0.4);
            tl.to(sym, { alpha: 0, duration: 0.4, ease: 'Power3.easeIn' }, startOffset + 0.4);
        });

        if (scatterCounter) {
            tl.add(() => {
                this.addSpinsView(scatterCounter);
            }, startOffset);
            startOffset += 1.2;
        }

        startOffset = tl.duration() - 0.2;
        Beheaded.soundPlayer.playSound(SoundConfig.WILD_SIZE_ACTIVE[size-1])

        for (let i = 0; i < size; i++) {
            this.soulWilds[i].scale.set(1 + size * 0.05);
            this.soulWilds[i].alpha = 1;
            tl.add(
                this.soulWilds[i].play({
                    animation: 'appear',
                    showOnEnd: true,
                    onComplete: () => {
                        this.soulWilds[i].play({ animation: 'loop', loop: true });
                    },
                }),
                startOffset
            );
        }

        startOffset = tl.duration();

        tl.add(() => {
            this.swirlySpine.play({
                animation: swirlAnim + '_W_appear',
                showOnEnd: true,
                onComplete: () => {
                    this.swirlySpine.play({ animation: swirlAnim + '_W_loop', loop: true });
                },
            });

            const tt = gsap.timeline();
            for (let i = 0; i < size; i++) {
                this.soulWilds[i].play({ animation: 'BigWin', showOnEnd: true, loop: true });
                const toPos = specialMovement(i, this.soulWilds[i].position, size, target.row == 3);
                tt.to(this.soulWilds[i], { x: toPos.x, y: toPos.y, duration: 0.5, ease: 'Back.easeOut' }, 0);
            }
        });

        function specialMovement(indx: number, pos: PIXI.Point, size: number, isBott: boolean): PIXI.Point {
            if (size == 3) {
                switch (indx) {
                    case 0:
                        return MathHelper.pointAdd(pos, new PIXI.Point(-50, 0));
                    case 1:
                        return MathHelper.pointAdd(pos, new PIXI.Point(50, 0));
                    default:
                        return MathHelper.pointAdd(pos, new PIXI.Point(0, -50));
                }
            } else if (size == 2) {
                switch (indx) {
                    case 0:
                        return MathHelper.pointAdd(pos, new PIXI.Point(-100, -45));
                    default:
                        return MathHelper.pointAdd(pos, new PIXI.Point(100, 45));
                }
            } else {
                return MathHelper.pointAdd(pos, new PIXI.Point(100, isBott ? -45 : 45));
            }
        }

        tl.to(this, { duration: this.swirlySpine.fetchDuration(swirlAnim + '_W_appear') });

        return tl;
    }

    public playWinAnimation(durr: number, size: number) {
        const swirlAnim: string = size + 'x' + size;

        return this.swirlySpine.play({
            animation: swirlAnim + '_W_win',
            showOnEnd: true,
            duration: durr,
            onStart: () => {
                SoundManager.playRandomFromList(SoundConfig.WILD_HIGHLIGHT,false);
            },
            onComplete: () => {
                this.swirlySpine.play({ animation: swirlAnim + '_W_loop', loop: true });
            },
        });
    }

    public killSoloJW():gsap.core.Timeline{
        BeheadedEngineManager.RAll((r) => r.switchRopeLayer(false));
        const tl = gsap.timeline({onComplete:() => {
            this.soulWilds[0].play({ animation: 'remove' });
        }});
        tl.add(() => {
            SoundManager.playSoundEffect(SoundConfig.SW_DISABLED);
        })
        tl.to(this.soulWilds[0], {alpha:0, y: "-=50", duration: 0.75 }, 0);
        return tl;
    }

    public moveJWToMult(size: number, NoWin: boolean): gsap.core.Timeline {
        const tl = gsap.timeline();

        BeheadedEngineManager.RAll((r) => r.switchRopeLayer(false));

        const moveDurr: number = 1;
        const offset: number = 0.075;

        tl.timeScale(GameSetting.isFastSpin || NoWin ? 2 : 1);
        const toPos = Helper.copyLocalPosition(this.soulWilds[0], Beheaded.baseMultiplier.multSpine);

        for (let i = 0; i < size; i++) {
            tl.to(this.soulWilds[i], { x: toPos.x, y: toPos.y, duration: 1, ease: 'Back.easeIn' }, i * offset);
            tl.to(this.soulWilds[i].scale, { x: 1, y: 1, duration: 1, ease: 'Back.easeIn' }, i * offset);
            tl.add(() => {
                this.soulWilds[i].play({ animation: 'remove' });
            }, i * offset + moveDurr);

            if (!i)
                tl.add(() => {
                    Beheaded.baseMultiplier.setValue(Beheaded.baseMultiplier.currentMult * size, undefined, size);
                }, i * offset + moveDurr);
        }

        tl.to(this, { duration: 0.35 });
        return tl;
    }

    private addSpinsView(ammScatters: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        this.addSpinsText.text = '+' + ammScatters;
        this.addSpinsText.position.set(this.swirlySpine.x - this.addSpinsText.width / 2, this.swirlySpine.y);
        this.addSpinsText2.position = this.addSpinsText.position;

        tl.fromTo(
            [this.addSpinsText, this.addSpinsText2],
            { alpha: 0 },
            { y: this.swirlySpine.y - 80, duration: 1.5, alpha: 1 },
            0
        );
        tl.fromTo(
            [this.addSpinsText.scale, this.addSpinsText2.scale],
            { x: 0, y: 0 },
            { x: 1, y: 1, duration: 1.5, ease: 'Back.easeOut' },
            0
        );
        tl.to([this.addSpinsText, this.addSpinsText2], { alpha: 0, duration: 0.5 }, '-=' + 0.5);
        return tl;
    }

    private setSwPositions(size: number): void {
        const referencePos = Helper.copyLocalPosition(this.soulWilds[0], this.swirlySpine);
        this.soulWilds.forEach((sw, swIndex) => {
            if (size === 2) {
                if (swIndex === 0) {
                    sw.position.x = referencePos.x - 50;
                    sw.position.y = referencePos.y;
                } else {
                    sw.position.x = referencePos.x + 50;
                    sw.position.y = referencePos.y;
                }
            } else if (size === 3) {
                if (swIndex === 0) {
                    sw.position.x = referencePos.x - 100;
                    sw.position.y = referencePos.y + 50;
                } else if (swIndex === 1) {
                    sw.position.x = referencePos.x + 100;
                    sw.position.y = referencePos.y + 50;
                } else {
                    sw.position.x = referencePos.x;
                    sw.position.y = referencePos.y - 90;
                }
            } else {
                sw.position.x = referencePos.x;
                sw.position.y = referencePos.y;
            }
        });
    }

    public remove(): gsap.core.Timeline {
        Beheaded.soundPlayer.fadeSound(SoundConfig.WILD_FIRE_LOOP, SoulWild.volumeFire, 0, 200);
        const tl = gsap.timeline({
            onComplete: () => {
                this.swirlySpine.stop(true);
                Beheaded.soundPlayer.stopSound(SoundConfig.WILD_FIRE_LOOP);
            },
        });

        tl.to(this.swirlySpine, { alpha: 0, duration: 0.5 }, 0);

        this.symbolsToGetSucky.forEach((s) => {
            s.position = new PIXI.Point(0, s.posID[0] * s.symbolHeight);
            s.alpha = 1;
            tl.add(s.convertToWild());
            tl.to(s.scale, { x: 1, y: 1, duration: 0.2 }, 0);
        });

        this.symbolsToGetSucky = [];

        return tl;
    }
}
